export default __webpack_public_path__ + "static/media/more-vertical.56e000ef.svg";